import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <main className='min-h-screen pt-[72px] flex items-center justify-center bg-linear-to-b from-primary to-primary/80 relative overflow-hidden'>
      <div className='absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none'>
        <div className='absolute top-20 left-20 w-96 h-96 bg-primary rounded-full blur-[128px] animate-pulse'></div>
        <div className='absolute bottom-20 right-20 w-96 h-96 bg-secondary rounded-full blur-[128px] animate-pulse delay-1000'></div>
      </div>

      <div className='relative z-10 text-center max-w-2xl px-6'>
        <h1 className='font-heading text-[10rem] md:text-[14rem] leading-none font-bold text-transparent bg-clip-text bg-linear-to-b from-white to-primary/10 select-none animate-in fade-in zoom-in duration-700'>
          404
        </h1>

        <div className='bg-white/70 backdrop-blur-md p-8 md:p-12 rounded-xl shadow-xl -mt-10 animate-in slide-in-from-bottom-8 duration-700 delay-200'>
          <h2 className='font-heading text-3xl md:text-4xl uppercase text-primary mb-4'>
            Page Not Found
          </h2>
          <p className='font-sans text-secondary text-lg mb-8 leading-relaxed'>
            Oops! The page you’re looking for doesn’t exist.<br />
            It might have been moved or deleted.
          </p>

          <div className='flex flex-col sm:flex-row gap-4 justify-center'>
            <Link
              to="/"
              className='flex items-center justify-center gap-2 px-8 py-3 bg-primary text-white rounded-sm font-bold uppercase tracking-widest hover:bg-secondary transition-all shadow-lg hover:shadow-xl group'
            >
              <Home className='w-4 h-4' /> Go Home
            </Link>
            <button
              onClick={() => window.history.back()}
              className='flex items-center justify-center gap-2 px-8 py-3 bg-secondary text-white rounded-sm font-bold uppercase tracking-widest hover:bg-primary transition-colors'
            >
              <ArrowLeft className='w-4 h-4' /> Go Back
            </button>
          </div>
        </div>

      </div>
    </main>
  );
};

export default NotFoundPage;